import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import calcularResultadosICV from '../utils/calcularResultadosICV';
import { auditarICV } from '../utils/auditarICV';

// ---------------------------------------------------------
// Perguntas (1..87) – mantém o mapeamento 0/1/2 no formulário
// ---------------------------------------------------------
const perguntas = [
  // 1 a 5
  { id: 1,  texto: "Você vai fazer uma viagem com uma pessoa que não conhece. Qual aspecto mais gostaria de saber para a viagem ser melhor?",
    opcoes: ["O estilo de vida dela","O que vocês têm em comum","Sua atividade e responsabilidades profissionais"] },
  { id: 2,  texto: "Qual tipo de vendedor de roupas tem mais chance de sucesso?",
    opcoes: ["O que apresenta as novidades primeiro","O que tenta conhecer o estilo de vida do cliente","O que tem boa capacidade de convencer"] },
  { id: 3,  texto: "Você vai apresentar um projeto importante para a diretoria. Qual qualidade mais te ajudaria a persuadir o público?",
    opcoes: ["Ter domínio técnico total do assunto","Adaptar seu raciocínio conforme a reação do público","Manter a ordem das ideias mesmo com interrupções"] },
  { id: 4,  texto: "Você é enviado contra a vontade para uma cidade desconhecida, para ficar algumas semanas. O que faria?",
    opcoes: ["Acharia que a estadia é curta demais para se adaptar","Tentaria aprender sobre o local e sua cultura para aproveitar melhor","Ter apenas o contato necessário para o trabalho"] },
  { id: 5,  texto: "Pessoas que dizem sempre 'a verdade' para os outros, mesmo que seja desagradável, fazem isso porque:",
    opcoes: ["Não sabem controlar seus impulsos, falam sem pensar","Não gostam de hipocrisia","Acham que isso simplifica as relações"] },

  // 6 a 10
  { id: 6,  texto: "Um amigo seu começou a carreira profissional com sucesso, mas acabou tendo vários fracassos. O que você pensa sobre isso?",
    opcoes: ["As condições não foram favoráveis","Ele não estava à altura","Não usou bem os meios para superar os desafios"] },
  { id: 7,  texto: "Você conhece alguém que aparenta idade muito menor do que realmente tem. O que pensa sobre isso?",
    opcoes: ["Provavelmente encontrou na vida o que lhe convinha","Teve sorte; é questão de natureza","Provavelmente teve uma vida fácil"] },
  { id: 8,  texto: "Você começa a praticar um novo esporte e percebe que não evolui rápido. O que faz?",
    opcoes: ["Pensa que não é para você e procura outro esporte","Acredita que não tem talento e busca outra atividade","Continua tentando, esperando que o esforço traga resultado"] },
  { id: 9,  texto: "Você está cansado, mas não consegue dormir porque os vizinhos fazem barulho. O que faz?",
    opcoes: ["Vai falar com os vizinhos","Bate no teto ou faz barulho de volta","Toma um remédio para dormir"] },
  { id: 10, texto: "Você precisa enviar uma mensagem urgente e só tem acesso ao telefone de um amigo. O que faz?",
    opcoes: ["Pede ao amigo para usar o telefone","Tenta convencer o responsável do local a deixar você enviar a mensagem","Procura outra forma ou local para resolver"] },

  // 11 a 15
  { id: 11, texto: "Em um país onde negociar preço é comum, qual seria sua atitude?",
    opcoes: ["Evitaria compras para não negociar","Compraria mais só para negociar","Prefere lojas com preço fixo"] },
  { id: 12, texto: "Sem considerar formação e competência, que setor de uma empresa você preferiria dirigir?",
    opcoes: ["Gestão","Pessoas","Publicidade"] },
  { id: 13, texto: "Um escritor pouco conhecido ganha um grande prêmio. O que você acha que ele faria?",
    opcoes: ["Curtiria o sucesso socialmente","Tentaria escrever uma obra-prima","Se dedicaria a outra arte"] },
  { id: 14, texto: "Numa prova, você pode escolher entre dois temas. Qual escolhe?",
    opcoes: ["O tema mais seguro para garantir nota média","O tema com chance de nota alta, mesmo com risco de nota baixa","Prefere que o professor escolha"] },
  { id: 15, texto: "Qual dessas atividades de lazer na natureza você prefere?",
    opcoes: ["Passeio de barco com mar agitado","Tomar sol na praia num dia calmo","Caminhada no campo na primavera"] },

  // 16 a 20
  { id: 16, texto: "O que mais atrai as pessoas em viagens ao exterior?",
    opcoes: ["Novos cenários","Descobrir outra cultura artística","Contato com costumes muito diferentes"] },
  { id: 17, texto: "Você está com pressa na rua e um jovem te para para fazer perguntas divertidas. O que faz?",
    opcoes: ["Recusa firmemente responder","Responde rapidamente por achar divertido","Diz que não tem tempo, mas fica triste por isso"] },
  { id: 18, texto: "Na sua empresa há pouca informação oficial. O que pensa?",
    opcoes: ["Será difícil se informar","Com as fofocas já se resolve","Basta conhecer as pessoas certas"] },
  { id: 19, texto: "Você vê alguém tentando abrir um carro com um objeto estranho na rua à noite. O que pensa?",
    opcoes: ["Deve ser ladrão; penso em chamar a polícia","Alguém tentando tirar um carro da frente","O que estará fazendo? Parece usar uma ferramenta estranha"] },
  { id: 20, texto: "Quando uma criança faz algo errado, qual melhor reação?",
    opcoes: ["Castigar e explicar o motivo","Explicar a situação e seu contexto","Apelar para o orgulho da criança"] },

  // 21 a 25
  { id: 21, texto: "Sobre educação sexual dos filhos, qual abordagem você adotaria?",
    opcoes: ["Planejar uma abordagem padrão e repetir para todos","Seguir a intuição e sentimentos do momento","Adotar abordagem diferente para cada filho"] },
  { id: 22, texto: "Qual a melhor forma de um filho apresentar notas ruins na escola?",
    opcoes: ["Mostrar logo para se livrar disso","Mostrar num momento mais calmo, tipo café da manhã","Apresentar junto com alguma notícia positiva"] },
  { id: 23, texto: "Seu filho entrou no escritório mesmo após ser proibido e derramou tinta em papéis importantes. Irritado, você grita de modo agressivo com ele. Como se sentiria depois?",
    opcoes: ["Acreditaria que castigos severos são necessários de vez em quando","Acharia que exagerou um pouco","Acreditaria que às vezes é melhor demonstrar irritação para não repetir o castigo"] },
  { id: 24, texto: "Alguém próximo a você te prejudicou. Como reage?",
    opcoes: ["Não demonstra, mas acha difícil esconder o ressentimento","Não diz nada porque acha que o dano foi menor do que parecia","Tenta esconder para não atrapalhar futuras relações"] },
  { id: 25, texto: "Em uma roda de conversa, sua opinião causa desconforto. O que seria mais desagradável?",
    opcoes: ["A dificuldade no contato com o grupo","Ser julgado pela observação feita","Se arrepender de ter falado sem pensar"] },

  // 26 a 30
  { id: 26, texto: "Jogando cartas com amigos, você perde várias vezes. Como reage?",
    opcoes: ["Pensa que aprendeu e vai ganhar na próxima","Acredita que sempre perde nesse jogo","Acha que não está com sorte naquele dia"] },
  { id: 27, texto: "Você está no cinema ao lado de pessoas que não param de conversar. O que faz?",
    opcoes: ["Pede para que façam silêncio","Troca de lugar","Tenta se concentrar no filme"] },
  { id: 28, texto: "Você faz mudanças no trabalho e recebe muitas críticas. O que faz?",
    opcoes: ["Tenta justificar sua posição","Pensa que nunca se agrada a todos","Reavalia o problema"] },
  { id: 29, texto: "Quando vê uma criança desafiando adultos, o que pensa?",
    opcoes: ["É mal-educada","Deve ter dificuldades de relacionamento","Tem personalidade forte"] },
  { id: 30, texto: "Você precisa contratar um colaborador para um cargo de chefia. Qual qualidade valoriza mais?",
    opcoes: ["Ter autoridade","Ser convincente","Ser justo"] },

  // 31 a 35
  { id: 31, texto: "Sobre dirigir em estrada, qual comportamento é mais comum?",
    opcoes: ["Dirigir com segurança e sem correr riscos","Ultrapassar só quando seguro","Ficar impaciente e ultrapassar sempre que possível"] },
  { id: 32, texto: "O que você mais valoriza num restaurante?",
    opcoes: ["Boa comida","Ambiente agradável","Pratos especiais da casa"] },
  { id: 33, texto: "Você vai às compras e percebe que esqueceu dinheiro e cartão. O que faz?",
    opcoes: ["Volta para buscar","Procura alguém conhecido para ajudar ou tenta comprar fiado","Aproveita para passear e deixa para outro dia"] },
  { id: 34, texto: "Depois de um ano de muito trabalho, você está de férias. O que prefere?",
    opcoes: ["Mês na praia para descansar","Visitar uma região desconhecida","Viagem longa de aventura ou esporte"] },
  { id: 35, texto: "Qual o melhor jeito de descansar no fim de semana para quem trabalha muito?",
    opcoes: ["Encontrar amigos","Ir ao cinema","Ler"] },

  // 36 a 40
  { id: 36, texto: "Se tivesse um ano livre com todos os recursos, o que escolheria?",
    opcoes: ["Dar a volta ao mundo sozinho","Participar de uma competição internacional","Visitar o maior número de países possível"] },
  { id: 37, texto: "Um novo colega pede dinheiro emprestado até o mês seguinte. O que faz?",
    opcoes: ["Empresta sem questionar para não constranger","Empresta porque gostaria que fizessem o mesmo com você","Não empresta, acreditando que outros amigos podem ajudar"] },
  { id: 38, texto: "Você precisa contratar um advogado. O que mais pesa na escolha?",
    opcoes: ["Sua reputação de eloqüência","Boas relações com o meio jurídico","Capacidade psicológica de entender as pessoas"] },
  { id: 39, texto: "Você assume uma posição de chefia. Qual será sua postura com subordinados?",
    opcoes: ["Adapta a liderança conforme as pessoas e situação","Usa o mesmo estilo de comando para todos","Segue a intuição com base na experiência"] },
  { id: 40, texto: "Precisa explicar um assunto complexo para leigos. O que é mais fácil para você?",
    opcoes: ["Usar linguagem acessível","Manter a atenção do público","Fazer todos participarem"] },

  // 41 a 45
  { id: 41, texto: "Você está num clássico do futebol entre dois times grandes. Todos torcem e vibram muito. O que faz?",
    opcoes: ["Aplaude apenas as melhores jogadas","Se envolve totalmente, grita e comemora como os outros","Discute lances com quem está por perto"] },
  { id: 42, texto: "Você atravessa a rua enquanto o semáforo está vermelho para pedestres. Um carro freia em cima de você. Qual sua reação imediata?",
    opcoes: ["Faz um comentário irônico e reclama por dentro","Reclama com o motorista sobre sua condução","Xinga o motorista sem conseguir se controlar"] },
  { id: 43, texto: "Qual aspecto mais falta na educação dos filhos hoje?",
    opcoes: ["Aceitação de responsabilidades","Gostar do trabalho bem feito","Capacidade de se virar sozinho"] },
  { id: 44, texto: "Você fracassou em uma prova. Um amigo diz que o fracasso é útil. O que responde?",
    opcoes: ["Acha que no seu lugar ele não pensaria assim","Pode até concordar","Admite que, quando acontece, é difícil aceitar"] },
  { id: 45, texto: "Em uma reunião social com pessoas que pensam diferente de você, como age?",
    opcoes: ["Evita discussão","Provoca debate","Dá opinião se não puder evitar"] },

  // 46 a 50
  { id: 46, texto: "Qual qualidade é mais útil nas relações sociais?",
    opcoes: ["Tolerância","Sinceridade","Capacidade de fazer acordos"] },
  { id: 47, texto: "Você mudou totalmente seu apartamento e convida amigos para ver. Qual elogio mais gosta?",
    opcoes: ["Sobre o bom gosto","Sobre o aproveitamento do espaço","Sobre a originalidade"] },
  { id: 48, texto: "Você chega durante uma discussão técnica sobre algo que não conhece. O que faz?",
    opcoes: ["Intervém para se informar, mesmo arriscando parecer leigo","Tenta se interessar para não ser indelicado","Não intervém por não ter o que acrescentar"] },
  { id: 49, texto: "Chega atrasado a uma reunião. O que mais incomoda?",
    opcoes: ["Achar que decidiram algo importante sem você","Ter dificuldade de se integrar à conversa","Parecer descortês"] },
  { id: 50, texto: "Se tivesse que pedir uma avaliação sobre si mesmo, quem escolheria?",
    opcoes: ["Sua parceira/parceiro","Um grupo de amigos","Você mesmo"] },

  // 51 a 55
  { id: 51, texto: "Vai construir uma casa. O que faz?",
    opcoes: ["Contrata um arquiteto","Faz o projeto e contrata um construtor","Faz o projeto com um amigo que já construiu"] },
  { id: 52, texto: "Você, normalmente ocupado, tem uma manhã livre inesperada. O que faz?",
    opcoes: ["Levanta cedo e pratica um esporte","Aproveita para planejar a semana","Desfruta sem compromisso, aproveitando para relaxar"] },
  { id: 53, texto: "Vai viajar para um lugar totalmente desconhecido. Como se prepara?",
    opcoes: ["Lê livros e guias sobre o local","Conversa com pessoas que já conhecem o local","Prefere descobrir tudo ao chegar"] },
  { id: 54, texto: "Por que, em geral, as pessoas não ajudam alguém passando mal na rua?",
    opcoes: ["Total indiferença com o próximo","Medo de situações inesperadas","Receio de se envolver no problema dos outros"] },
  { id: 55, texto: "Uma senhora vai ao médico por algo aparentemente banal. O médico faz muitas perguntas antes do exame. O que ela pensa?",
    opcoes: ["Eu começaria pelo exame, depois perguntaria","Ele precisa saber como peguei essa doença","Algumas perguntas não fazem sentido para mim"] },

  // 56 a 60
  { id: 56, texto: "Precisa contratar funcionários para escritório com pouco tempo. Que método usa?",
    opcoes: ["Entrevista todos os candidatos","Avalia currículo e referências","Aplica uma prova prática"] },
  { id: 57, texto: "O melhor representante dos funcionários é aquele que:",
    opcoes: ["É bom negociador","Acredita na causa","É bem integrado à equipe"] },
  { id: 58, texto: "Qual característica mais ajuda a ter sucesso profissional?",
    opcoes: ["Facilidade de adaptação","Forte motivação pessoal","Bons contatos e rede de apoio"] },
  { id: 59, texto: "Qual dessas habilidades seria mais útil em situação de conflito?",
    opcoes: ["Saber ouvir","Ser firme nas opiniões","Manter bom humor"] },
  { id: 60, texto: "Na avaliação de desempenho, o que mais valoriza?",
    opcoes: ["Reconhecimento público","Aumento de salário","Desafio e novos aprendizados"] },

  // 61 a 65
  { id: 61, texto: "No feriadão, decide viajar com amigos. Como preferem ir?",
    opcoes: ["De carro próprio, revezando motoristas","De avião para aproveitar melhor o destino","De ônibus só se não tiver outra opção"] },
  { id: 62, texto: "Você recebe um prêmio importante no trabalho. Qual sua reação?",
    opcoes: ["Fica muito feliz e compartilha com todos","Sente-se motivado a buscar mais conquistas","Prefere manter a notícia reservada"] },
  { id: 63, texto: "Quando recebe feedback negativo, o que pensa?",
    opcoes: ["Fica desconfortável, mas tenta melhorar","Busca entender e aprender","Desconsidera se não achar justo"] },
  { id: 64, texto: "Um colega está sempre atrasado para reuniões. O que faz?",
    opcoes: ["Comenta com ele diretamente","Leva o fato ao superior","Tenta contornar, ajustando a agenda"] },
  { id: 65, texto: "Qual é o principal motivo para você mudar de emprego?",
    opcoes: ["Melhor salário","Buscar crescimento profissional","Ambiente de trabalho ruim"] },

  // 66 a 70
  { id: 66, texto: "Se fosse trabalhar em outro país, o que mais te preocuparia?",
    opcoes: ["Adaptação à cultura local","Domínio do idioma","Distância da família e amigos"] },
  { id: 67, texto: "O que é mais importante para o sucesso de uma equipe?",
    opcoes: ["Liderança forte","Comunicação eficiente","Motivação dos membros"] },
  { id: 68, texto: "Num evento de networking, você costuma:",
    opcoes: ["Fazer muitos contatos rapidamente","Conversar com poucas pessoas, mas profundamente","Observar antes de interagir"] },
  { id: 69, texto: "Qual dessas situações seria mais desconfortável?",
    opcoes: ["Ficar sem bateria no celular em viagem","Perder documentos importantes","Esquecer um compromisso essencial"] },
  { id: 70, texto: "Ao iniciar um novo projeto, qual sua prioridade?",
    opcoes: ["Planejar detalhadamente","Formar uma boa equipe","Começar logo para ganhar tempo"] },

  // 71 a 75
  { id: 71, texto: "Qual atitude você valoriza mais em um líder?",
    opcoes: ["Inspira confiança","Dá autonomia à equipe","Reconhece o esforço de todos"] },
  { id: 72, texto: "Em uma negociação difícil, o que você faz?",
    opcoes: ["Defende seus interesses até o fim","Cede em alguns pontos para avançar","Busca acordo equilibrado para todos"] },
  { id: 73, texto: "Sobre inovação, você costuma:",
    opcoes: ["Buscar sempre o novo","Acompanhar tendências, mas sem arriscar muito","Manter o que já funciona"] },
  { id: 74, texto: "Quando precisa estudar um tema novo, prefere:",
    opcoes: ["Estudar sozinho no seu ritmo","Participar de grupos de estudo","Ter um tutor ou mentor"] },
  { id: 75, texto: "Se pudesse mudar algo no seu trabalho, o que seria?",
    opcoes: ["A rotina de tarefas","As metas e cobranças","O relacionamento com colegas"] },

  // 76 a 80
  { id: 76, texto: "Na sua opinião, qual a maior dificuldade de ser gestor?",
    opcoes: ["Tomar decisões impopulares","Conciliar interesses diferentes","Lidar com pressão por resultados"] },
  { id: 77, texto: "Você tem que dar um feedback negativo para alguém. O que faz?",
    opcoes: ["Diz diretamente, sem rodeios","Tenta amenizar e equilibrar com elogios","Prefere não dizer para evitar conflito"] },
  { id: 78, texto: "Como costuma organizar suas tarefas?",
    opcoes: ["Usa agenda e listas","Segue um planejamento semanal","Organiza conforme as demandas surgem"] },
  { id: 79, texto: "Em reuniões longas, o que mais te incomoda?",
    opcoes: ["Desvios de foco e assuntos irrelevantes","Falta de objetividade","Participação desigual entre os membros"] },
  { id: 80, texto: "Você recebe uma crítica pública. Como reage?",
    opcoes: ["Fica incomodado, mas reflete depois","Rebate imediatamente","Ignora para não gerar discussão"] },

  // 81 a 85
  { id: 81, texto: "O que mais te motiva no trabalho?",
    opcoes: ["Reconhecimento","Desafios","Autonomia"] },
  { id: 82, texto: "No metrô ou ônibus lotado, uma pessoa acende um cigarro, o que você faz?",
    opcoes: ["Pede para apagar explicando que é proibido por lei","Se afasta ou muda de lugar","Chama o segurança ou avisa o motorista"] },
  { id: 83, texto: "Quando precisa relaxar após um dia difícil, o que faz?",
    opcoes: ["Sai com amigos ou familiares","Assiste a um filme ou série","Pratica esporte ou exercício"] },
  { id: 84, texto: "Sobre mudanças na vida, como costuma reagir?",
    opcoes: ["Resiste inicialmente, mas depois se adapta","Encarar como oportunidade de crescimento","Sente-se inseguro e ansioso"] },
  { id: 85, texto: "Qual desses problemas você considera mais grave?",
    opcoes: ["Falta de ética","Falta de competência","Falta de empatia"] },

  // 86 e 87
  { id: 86, texto: "Qual dessas conquistas te deixaria mais realizado?",
    opcoes: ["Ser referência na sua área","Ter estabilidade financeira","Equilibrar vida pessoal e profissional"] },
  { id: 87, texto: "O que é mais importante para você em um time de vendas?",
    opcoes: ["Resultados expressivos","Clima positivo","Oportunidades de desenvolvimento"] },
];

// ------------------------------------
// Hook simples para detectar mobile
// ------------------------------------
function useIsMobile(breakpoint = 992) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );
  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e) => setIsMobile(e.matches);
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [breakpoint]);
  return isMobile;
}

// ------------------------------------
// Componente principal
// ------------------------------------
export default function ICVForm() {
  const [respostas, setRespostas] = useState(Array(perguntas.length).fill(''));
  const [pagina, setPagina] = useState(1);
  const navigate = useNavigate();
  const isMobile = useIsMobile(992);

  // Paginação
  const perguntasPorPagina = 5;
  const totalPaginas = Math.ceil(perguntas.length / perguntasPorPagina);
  const inicio = (pagina - 1) * perguntasPorPagina;
  const fim = inicio + perguntasPorPagina;

  function responder(indicePergunta, valor) {
    const novas = [...respostas];
    novas[inicio + indicePergunta] = valor; // "0" | "1" | "2"
    setRespostas(novas);
  }

  const podeAvancar = respostas.slice(inicio, fim).every(r => r !== '');

  function handleFinalizar() {
    // Calcula brutos e PTs diretamente a partir do array 0/1/2
    const { brutos, pts } = calcularResultadosICV(respostas);



// ...
const audit = auditarICV(respostas);
console.log('AUDIT ICV ===>', audit);

    
    // Envia para o relatório
    navigate('/relatorio-icv', { state: { ptResultados: pts, brutos } });
  }

  // Estilos
  const containerStyle = {
    width: '100%', maxWidth: 640, margin: '2rem auto',
    padding: isMobile ? '1rem' : '2rem 1.5rem',
    background: '#fff', borderRadius: 12,
    boxShadow: '0 2px 10px rgba(36,47,60,0.10)', fontFamily: 'inherit'
  };
  const perguntaStyle = { marginBottom: 28 };
  const opcaoStyle = {
    display: 'block', width: '100%', marginBottom: 10,
    borderRadius: 7, border: '1px solid #eaeaea',
    padding: '10px 12px', cursor: 'pointer', background: '#f6f8fa'
  };
  const btnBase = {
    padding: '0.7rem 2.5rem', color: '#fff', border: 'none',
    borderRadius: 6, fontWeight: 600, width: isMobile ? '100%' : 'auto'
  };

  return (
    <div style={containerStyle}>
      {/* Introdução */}
      <div style={{
        background:'#F5FAFF', borderRadius:10,
        padding: isMobile ? '1rem' : '1.5rem',
        marginBottom:'2rem', border:'1px solid #E6EDF3'
      }}>
        <h2 style={{marginBottom:'0.5rem', fontWeight:700, color:'#242F3C'}}>
          Bem-vindo ao Inventário de Competências para Vendas
        </h2>
        <p style={{fontSize: isMobile ? 14 : 15, color:'#222', lineHeight: 1.5}}>
          <b>Orientações:</b><br/>
          Responda todas as perguntas com sinceridade, pensando em situações reais do seu cotidiano de trabalho.<br/>
          Não há respostas certas ou erradas. O objetivo é traçar seu perfil para desenvolvimento profissional.<br/>
          O formulário possui várias etapas e deve ser respondido de uma só vez.<br/>
          Clique em <b>Avançar</b> para ir para o próximo bloco ou <b>Voltar</b> para revisar respostas anteriores.
        </p>
      </div>

      {/* Perguntas */}
      {perguntas.slice(inicio, fim).map((pergunta, i) => (
        <div key={pergunta.id} style={perguntaStyle}>
          <strong style={{fontSize:16, display:'block', marginBottom:8}}>
            {`${pergunta.id}. ${pergunta.texto}`}
          </strong>
          <div>
            {pergunta.opcoes.map((op, j) => (
              <label key={j} style={opcaoStyle}>
                <input
                  type="radio"
                  name={`pergunta${pergunta.id}`}
                  checked={respostas[inicio + i] === String(j)}
                  onChange={() => responder(i, String(j))}
                  style={{ marginRight: 8 }}
                />
                {op}
              </label>
            ))}
          </div>
        </div>
      ))}

      {/* Botões */}
      <div
        style={{
          display:'flex',
          justifyContent: isMobile ? 'flex-start' : 'space-between',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 12 : 0,
          marginTop:'2rem'
        }}
      >
        <button
          style={{ ...btnBase, background: pagina === 1 ? '#ccc' : '#313B47' }}
          disabled={pagina === 1}
          onClick={() => setPagina(pagina - 1)}
        >
          Voltar
        </button>

        <button
          style={{ ...btnBase, background: podeAvancar ? '#FF6A00' : '#ccc' }}
          disabled={!podeAvancar}
          onClick={() => {
            if (pagina < totalPaginas) setPagina(pagina + 1);
            else handleFinalizar();
          }}
        >
          {pagina < totalPaginas ? 'Avançar' : 'Finalizar'}
        </button>
      </div>

      {/* Paginação */}
      <div style={{marginTop: 18, textAlign:'center', color:'#888', fontSize:14}}>
        Página {pagina} de {totalPaginas}
      </div>
    </div>
  );
}
